import { ToolBase } from "./_helpers";
/** The logic for the DC Power calculator */
export class OhmsLawCalculator extends ToolBase {
    constructor() {
        super("tools-ohms-law");
    }
    onLoad() {
        this.voltsBox = this.loadNumberBox('input-volts');
        this.currentBox = this.loadNumberBox('input-amps');
        this.ohmsBox = this.loadNumberBox('input-ohms');
    }
    onSubmit() {
        if (!this.checkAtLeastOneBoxIsEmpty(this.voltsBox, this.currentBox, this.ohmsBox))
            return;
        if (this.checkHasNValues([this.voltsBox, this.currentBox, this.ohmsBox], 2)) {
            let volts = +this.voltsBox.value;
            let amps = +this.currentBox.value;
            let ohms = +this.ohmsBox.value;
            if (this.voltsBox.value == "")
                this.voltsBox.value = (amps / ohms).toString();
            else if (this.currentBox.value == "")
                this.currentBox.value = (volts / ohms).toString();
            else if (this.ohmsBox.value == "")
                this.ohmsBox.value = (volts / amps).toString();
        }
    }
    onClear() {
        this.voltsBox.value = "";
        this.currentBox.value = "";
        this.ohmsBox.value = "";
    }
}
;
